module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "rew"
    }
  }, [_c('a', {
    attrs: {
      "id": "page01"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("The body count keeps rising…")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("The Charmed Killer is on the loose in Atlanta and Carlotta Wren is caught up in the terror—especially when her body-moving side business brings her dangerously close to the action.")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And then…")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("She’s forced to take refuge in her former fiancé’s house—much to the chagrin of other interested parties…")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("Her brother Wesley begins to behave as if he has his own death wish…")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("And someone close to her is implicated in the mass murders.")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("Meanwhile, Carlotta can’t shake the feeling that danger is dogging her seemingly cursed family—and that the serial killer’s exploits are starting to get personal….")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Look for all six books in Stephanie Bond’s Body Movers series, available now from Harlequin MIRA!")])])])])]), _c('a', {
    attrs: {
      "id": "page01"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ffd115c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5bodiestodiefor_rev01.vue
// module id = 60
// module chunks = 0